import React from 'react';
import ReactDOM from 'react-dom/client';
import LPVSok from './Components/LPVSok/LPVSok';
import setupHeaderAndFooter, {SearchSite} from './utils/setupHeaderAndFooter';
import 'udirsok-index.js'

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render( <LPVSok/> );

setupHeaderAndFooter(SearchSite.LPV);
